import AEditor from "./editor";
import AUtils from "./utils";
import TextAreaUtils from "./textarea";

class AccessoriesPro {
    constructor() {
        // 获取编辑器
        this.initEditor();
        // 导入工具类
        this.utils = new AUtils(this.editor);
        this.options = window.AConf.options;
        this.text = window.AConf.i18n;
        // 初始化
        this.initInput();
        this.initAttachArea();
    }

    /**
     * 增强输入框
     */
    initInput() {
        $.fn.extend({
            insertAtCursor: function (iValue) {
                let $t = $(this)[0];
                if (document.selection) {
                    this.focus();
                    let sel = document.selection.createRange();
                    sel.text = iValue;
                    this.focus();
                } else if ($t.selectionStart || $t.selectionStart == '0') {
                    let startPos = $t.selectionStart;
                    let endPos = $t.selectionEnd;
                    let scrollTop = $t.scrollTop;
                    $t.value = $t.value.substring(0, startPos) + iValue + $t.value.substring(endPos, $t.value.length);
                    this.focus();
                    $t.selectionStart = startPos + iValue.length;
                    $t.selectionEnd = startPos + iValue.length;
                    $t.scrollTop = scrollTop;
                } else {
                    this.value += iValue;
                    this.focus();
                }
            },
            selection: function () {
                let s, e, range, stored_range;
                if (this[0].selectionStart == undefined) {
                    let selection = document.selection;
                    if (this[0].tagName.toLowerCase() != "textarea") {
                        let val = this.val();
                        range = selection.createRange().duplicate();
                        range.moveEnd("character", val.length);
                        s = (range.text == "" ? val.length : val.lastIndexOf(range.text));
                        range = selection.createRange().duplicate();
                        range.moveStart("character", -val.length);
                        e = range.text.length;
                    } else {
                        range = selection.createRange(),
                            stored_range = range.duplicate();
                        stored_range.moveToElementText(this[0]);
                        stored_range.setEndPoint('EndToEnd', range);
                        s = stored_range.text.length - range.text.length;
                        e = s + range.text.length;
                    }
                } else {
                    s = this[0].selectionStart,
                        e = this[0].selectionEnd;
                }
                let te = this[0].value.substring(s, e);
                return {start: s, end: e, text: te};
            }
        });
    }

    /**
     * 获取编辑器
     */
    initEditor() {
        let _editor = null;
        if (typeof window.postEditormd != "undefined") {
            _editor = window.postEditormd;
        } else if (typeof window.XEditor != "undefined") {
            _editor = window.XEditor;
        } else if (typeof window.vditor != "undefined") {
            _editor = window.vditor;
        } else if (typeof window.ue1 != "undefined") {
            _editor = window.ue1;
        } else if (typeof window.JoeHookedEditor != "undefined" && typeof window.JoeHookedEditor.cm != "undefined") {
            _editor = window.JoeHookedEditor;
            const { cm } = _editor;
            // 给 Joe 编辑器加入兼容函数
            _editor.getSelection = () => {
                return cm.state.sliceDoc(cm.state.selection.main.from, cm.state.selection.main.to);
            }
            _editor.replaceSelection = (str) => {
                cm.dispatch(cm.state.replaceSelection(str));
            }
        }
        else {
            _editor = $("#text");
            if (_editor.get(0).tagName.toLowerCase() === "textarea" && _editor.css("display") !== "none") {
                _editor = new TextAreaUtils('#text')
            } else {
                _editor = $("#text");
            }
        }
        this.editor = new AEditor(_editor);
    }

    /**
     * 初始化附件区域
     */
    initAttachArea() {

        let _this = this;
        // 遍历添加按钮，查询附件类型
        $('#file-list li').each(function (num, el) {
            _this.utils._updateAttachMode(el, true);
            _this.utils._updateAttachItem(el);
            _this.utils._attachClickEvent(el);
        });

        // 处理附件上传完成 防止覆盖 Typecho.uploadComplete 导致别的插件失效
        $('#file-list').on('DOMSubtreeModified', function () {
            $('#file-list li[id]').each(function (num, el) {
                if ($(el).data('skip') == undefined && $(el).css('display') != "none") {
                    _this.utils._updateAttachMode(el, true);
                    _this.utils._updateAttachItem(el);
                }
            });
        });

        // 添加外链附件/网盘附件
        $('.upload-file').after(`<br> ${this.text.or} <a class="accessories-add" href="#" data-mode="external">${this.text.operate.add}${this.text.mode.external}</a><br> ${this.text.or} <a class="accessories-add" href="#" data-mode="netdisk">${this.text.operate.add}${this.text.mode.netdisk}</a>`);
        $('.upload-area > .accessories-add').on('click', el => {
            let mode = $(el.target).data('mode');
            if (mode == 'external') {
                _this.utils._addExternal();
            } else if (mode == 'netdisk') {
                _this.utils._addNetdisk();
            }
            return false;
        })

        // 附件一次性插入
        if (this.options.enableInsertAll) {
            if ($('#ph-insert-images').length == 0)
                $('#upload-panel').append(`<span id="ph-insert-images" class="ph-btn">${this.text.insert.allImages}</span>`);

            $('#ph-insert-images').off('click').on('click', function () {
                let fileList = $('#file-list').children('li'),
                    text = "";
                fileList.each((num, el) => {
                    let item = $(el);
                    if (item.data('image')) {
                        text += "\n" + _this.options.insertImageTemplate.replace('{name}', item.find('.insert').text()).replace('{url}', item.data('url'));
                    }
                });
                _this.editor.replaceSelection(text);
            });
            // 歪路修复神奇的 Vditor BUG
            $("#ph-insert-images").on('DOMSubtreeModified', () => {
                $("#ph-insert-images").html(this.text.insert.allImages);
            });

            if ($('#ph-insert-non-images').length == 0)
                $('#upload-panel').append(`<span id="ph-insert-non-images" class="ph-btn">${this.text.insert.allNonImages}</span>`);

            $('#ph-insert-non-images').off('click').on('click', function () {
                let fileList = $('#file-list').children('li'),
                    text = "";
                fileList.each((num, el) => {
                    let item = $(el);
                    if (!item.data('image')) {
                        text += `\n[attach]${item.data('cid')}[/attach]`;
                    }
                });
                _this.editor.replaceSelection(text);
            });
            // 歪路修复神奇的 Vditor BUG
            $("#ph-insert-non-images").on('DOMSubtreeModified', () => {
                $("#ph-insert-non-images").html(this.text.insert.allNonImages);
            });

        }
    }
}

document.addEventListener('DOMContentLoaded', () => window.AccessoriesPro = new AccessoriesPro());
